
import ASYNC_STATUS from '../constants/async/status';

export const asyncService = async (service, time = 3000) => {
    const qs = {
        async: true
    };

    let response = await service(qs);

    const status = response?.task?.status;
    const result = response?.task?.result;
    qs.async = response?.task?.id;

    while (response?.task?.status?.id === ASYNC_STATUS.awaiting) {
        await sleep(time);
        response = await service(qs);
    };

    const responseSuccess = !('error' in response?.task?.result);
    const asyncHasError = status?.id === ASYNC_STATUS.error;
    const codeError = result?.code >= 400;

    if (asyncHasError || (status?.id && !responseSuccess) || codeError) {
        // eslint-disable-next-line no-throw-literal
        throw response?.task?.result;
    }

    return response;
};
export function sleep (ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}
export class CustomError extends Error {
    constructor (message) {
        super(JSON.stringify(message));
        this.name = this.constructor.name;
        this.response = {
            data: JSON.parse(this.message)
        };
    }

    from () {
        return JSON.parse(this.message);
    }
}
